/* Greenleaf — question lists open one at a time, and a link can open one. 11 Oct 2026 (Andrew's yes).
 *
 * Every question (<details class="qlist__item">) has an id and a shared `name`. Browsers that know `name` already
 * close the others; this file does it for the ones that do not, and opens the question a link points at:
 * /pages/repairs#cleaning scrolls to it and opens it, on arrival, on a hash change, and on a second click of a
 * link whose hash is already current (which fires no hashchange). Without this file the lists still open and close.
 */
(function () {
  'use strict';
  if (window.__glFaq) return;
  window.__glFaq = true;
  var SEL = 'details.qlist__item';

  function closeOthers(el) {
    var name = el.getAttribute('name');
    if (!name) return;
    var all = document.querySelectorAll(SEL + '[name="' + name + '"]');
    for (var i = 0; i < all.length; i++) if (all[i] !== el && all[i].open) all[i].open = false;
  }
  function openId(id, scroll) {
    if (!id) return false;
    var el;
    try { el = document.getElementById(decodeURIComponent(id)); } catch (e) { return false; }
    if (!el || !el.matches || !el.matches(SEL)) return false;
    /* .gl-faq-jump switches off the open/close animation (site.css, MOTION SYSTEM) for this one change, so
       the page lands on the question at its final place instead of where it was mid-animation. */
    var root = document.documentElement;
    root.classList.add('gl-faq-jump');
    closeOthers(el);
    el.open = true;
    if (scroll) el.scrollIntoView({ block: 'start' });
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('gl-faq-jump'); }); });
    return true;
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches(SEL) && d.open) closeOthers(d);
  }, true);
  window.addEventListener('hashchange', function () { openId(location.hash.slice(1), true); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    var hash = href.slice(href.indexOf('#') + 1);
    var path = href.split('#')[0];
    if (path && path !== location.pathname && path !== location.pathname + location.search) return;
    if (openId(hash, true)) { /* the browser's own jump follows */ }
  });
  function arrive() { openId(location.hash.slice(1), true); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrive); else arrive();
})();
